import React from "react"
import { EndpointConfig, RoutesConfig } from "../../config"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import * as yup from "yup"
import { validateYup } from "../template-info/templateUtils"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import { useLocation, useNavigate } from "react-router-dom"
import { authenticate } from "../../helper/auth"

function Invite() {
	const location = useLocation()

	const [form, setForm] = React.useState({
		password: "",
		token: ""
	})

	const [loading, setLoading] = React.useState(false)

	const [errors, setErrors] = React.useState({})

	const navigation = useNavigate()

	const updatePassword = () => {
		let schema = yup.object().shape({
			password: yup.string().trim().required("Required"),
			token: yup.string().trim().required("Required")
		})
		validateYup(schema, form)
			.then(() => {
				setLoading(true)
				;(async () => {
					const response = await axiosInstance.post(EndpointConfig.UserActivate, {
						password: form.password,
						token: form.token
					})

					authenticate(response, () => {
						navigation(RoutesConfig.UserLogin)
					})
				})()
					.catch((error) => {
						console.error(error)

						if (error?.response?.data?.error) {
							toast(error.response.data.error)
						} else {
							toast("Something went wrong")
						}
					})

					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	React.useEffect(() => {
		const urlSearchParam = new URLSearchParams(location.search)

		const details = {}

		for (const [key, value] of urlSearchParam) {
			details[key] = value
		}

		if (details.token) {
			setForm({
				...form,
				token: details.token
			})
		} else {
			toast("Invalid token")
		}
	}, [])

	return (
		<div className="flex flex-col">
			<h1 className="px-8 py-3 text-lg font-bold text-white bg-blue-500 shadow">Invite</h1>
			<div className="my-8"></div>
			<div className="flex flex-row items-center justify-center">
				<div className="flex flex-col items-center justify-center h-full">
					<div className="p-4 bg-white rounded-lg shadow-lg w-96">
						{form?.token && (
							<>
								<span className="text-xs text-gray-500 uppercase">
									Set Password
								</span>
								<Input
									name="password"
									error={errors?.password}
									value={form.password}
									label={"Password"}
									type="password"
									placeholder={"Password"}
									onChange={(e) => setForm({ ...form, password: e.target.value })}
								/>
								{loading ? (
									<Button className="w-full text-black bg-red-100 pointer-events-none ">
										Loading
									</Button>
								) : (
									<Button className="w-full " onClick={updatePassword}>
										Update Password
									</Button>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Invite
